"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _lodash = _interopRequireDefault(require("lodash.uniqueid"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Utils = exports["default"] = /*#__PURE__*/function () {
  function Utils() {
    _classCallCheck(this, Utils);
  }
  return _createClass(Utils, null, [{
    key: "formatDate",
    value: function formatDate(s, type) {
      var date = Date.parse(s);
      if (isNaN(date)) return "";
      if (Utils.isToday(date)) return "Today";
      return new Intl.DateTimeFormat("en-GB", typeof type === "string" ? type === "long" ? {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true
      } : {
        year: "numeric",
        month: "short",
        day: "numeric"
      } : type).format(date);
    }
  }, {
    key: "isToday",
    value: function isToday(date) {
      if (typeof date.getDate !== "function") return false;
      var today = new Date();
      return date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
    }
  }, {
    key: "toApiDate",
    value: function toApiDate(date) {
      if (!date) return null;
      var offset = date.getTimezoneOffset();
      var d = new Date(date.getTime() - offset * 60 * 1000);
      return d.toISOString().split("T")[0];
    }
  }, {
    key: "formatReadableDate",
    value: function formatReadableDate(date) {
      if (!date) return null;
      var yyyy = date.getFullYear().toString();
      var mm = (date.getMonth() + 1).toString();
      var dd = date.getDate().toString();
      return dd + "/" + mm + "/" + yyyy;
    }
  }, {
    key: "parseApiDate",
    value: function parseApiDate(date) {
      return date ? new Date(Date.parse(date)) : date;
    }
  }, {
    key: "formatProficiency",
    value: function formatProficiency(prof, valid) {
      return prof && prof > 0 && (valid === undefined || valid) ? Utils.formatNumber(prof) : "n/a";
    }
  }, {
    key: "formatProficiencyFraction",
    value: function formatProficiencyFraction(currentProf, requiredProf, valid) {
      return currentProf && currentProf > 0 && requiredProf && requiredProf > 0 && (valid === undefined || valid) ? Utils.formatProficiency(currentProf, valid) + " / " + Utils.formatProficiency(requiredProf, valid) : "n/a";
    }
  }, {
    key: "formatPercent",
    value: function formatPercent(n) {
      if (n === null || isNaN(n)) return "n/a";
      return Math.ceil(n) + "%";
    }
  }, {
    key: "roundNumber",
    value: function roundNumber(num) {
      var dec = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      return +(Math.round(num + "e+" + dec) + "e-" + dec);
    }
  }, {
    key: "zeroPadNumber",
    value: function zeroPadNumber(num, zeros) {
      return String(num).padStart(zeros, "0");
    }
  }, {
    key: "formatNumber",
    value: function formatNumber(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }, {
    key: "formatCurrency",
    value: function formatCurrency(num) {
      var dec = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return parseInt(num, 10).toLocaleString("en-US", {
        minimumFractionDigits: dec
      });
    }
  }, {
    key: "setCookie",
    value: function setCookie(name, value) {
      var days = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 7;
      var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "/";
      var expires = days === -1 ? "Thu, 01 Jan 1970 00:00:00 GMT" : new Date(Date.now() + days * 864e5).toUTCString();
      //document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=' + path + ';samesite=none';
      //document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=' + path + ';samesite=none; domain=localhost:9631';
      //document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=' + path + ';samesite=none; domain=localhost';

      //Cookies.set(name, value, { expires: days, path, sameSite: 'none' })

      //alert(document.cookie);
    }
  }, {
    key: "getCookie",
    value: function getCookie(name) {
      return document.cookie.split("; ").reduce(function (r, v) {
        var parts = v.split("=");
        return parts[0] === name ? decodeURIComponent(parts[1]) : r;
      }, "");
    }
  }, {
    key: "truncate",
    value: function truncate(input, limit) {
      if (!input) return input;
      return input.length > limit ? input.substring(0, limit) + "..." : input;
    }
  }, {
    key: "deleteCookie",
    value: function deleteCookie(name, path) {
      _jsCookie["default"].remove(name, {
        path: path,
        sameSite: "none"
      });
    }
  }, {
    key: "getDevOption",
    value: function getDevOption(key) {
      return window.localStorage.getItem(key) === "true";
    }
  }, {
    key: "setDevOption",
    value: function setDevOption(key, value) {
      window.localStorage.setItem(key, value);
    }
  }, {
    key: "getLocalStorageOption",
    value: function getLocalStorageOption(key) {
      return window.localStorage.getItem(key);
    }
  }, {
    key: "checkLocalStorageOption",
    value: function checkLocalStorageOption(key) {
      return window.localStorage.getItem(key) === "true";
    }
  }, {
    key: "setLocalStorageOption",
    value: function setLocalStorageOption(key, value) {
      window.localStorage.setItem(key, value);
    }
  }, {
    key: "removeLocationHash",
    value: function removeLocationHash() {
      window.history.pushState("", document.title, window.location.pathname, window.location.search);
    }
  }, {
    key: "setLocation",
    value: function setLocation(history, path, useNative) {
      if (useNative === true) window.history.pushState(null, "", path);else history.push(path);
    }
  }, {
    key: "isValidEmail",
    value: function isValidEmail(email) {
      return email ? email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) !== null : false;
    }
  }, {
    key: "isPasswordValid",
    value: function isPasswordValid(password) {
      return Utils.validatePassword(password, 3);
    }
  }, {
    key: "validatePassword",
    value: function validatePassword(password) {
      var numRequirements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
      if (password.length < 8) return false;
      if (password.length > 64) return false;
      var checks = 0;
      if (password.search(/[a-z]/) !== -1) checks++;
      if (checks >= numRequirements) return true;
      if (password.search(/[A-Z]/) !== -1) checks++;
      if (checks >= numRequirements) return true;
      if (password.search(/[0-9]/) !== -1) checks++;
      if (checks >= numRequirements) return true;
      if (password.search(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/) !== -1) checks++;
      return checks >= numRequirements;
    }
  }, {
    key: "isTouchDevice",
    value: function isTouchDevice() {
      return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.maxTouchPoints > 0;
    }
  }, {
    key: "generateUniqueId",
    value: function generateUniqueId(prefix) {
      return (0, _lodash["default"])(prefix);
    }
  }, {
    key: "compareList",
    value: function compareList(list1, list2, comparator) {
      if (!list1 || !list2) return false;
      if (list1.length !== list2.length) return false;
      var matches = true;
      list1.forEach(function (c) {
        if (!list2.some(function (c2) {
          return comparator(c2, c);
        })) matches = false;
      });
      return matches;
    }
  }, {
    key: "pluralize",
    value: function pluralize(count, noun) {
      var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "s";
      return Utils.formatNumber(count) + " " + noun + (count !== 1 ? suffix : "");
    }
  }, {
    key: "isOrAre",
    value: function isOrAre(count) {
      return count === 1 ? "is" : "are";
    }
  }]);
}();